/**
 * Generate idempotency key for financial operations
 * Format: {userId}-{operation}-{timestamp}-{random}
 */
export function generateIdempotencyKey(userId, operation) {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 15);
  return `${userId}-${operation}-${timestamp}-${random}`;
}

/**
 * Store idempotency key in sessionStorage
 * Prevents duplicate requests within same session
 */
export function storeIdempotencyKey(key, data) {
  try {
    const stored = {
      key,
      data,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(`idem_${key}`, JSON.stringify(stored));
  } catch (e) {
    console.warn('Failed to store idempotency key:', e);
  }
}

/**
 * Check if operation was already completed this session
 */
export function checkIdempotencyKey(key) {
  try {
    const stored = sessionStorage.getItem(`idem_${key}`);
    if (!stored) return null;
    
    const parsed = JSON.parse(stored);
    const age = Date.now() - parsed.timestamp;
    
    // Keys valid for 1 hour
    if (age > 60 * 60 * 1000) {
      sessionStorage.removeItem(`idem_${key}`);
      return null;
    }
    
    return parsed;
  } catch (e) {
    return null;
  }
}

/**
 * Clear old idempotency keys (call on app startup)
 */
export function cleanupIdempotencyKeys() {
  try {
    const keys = Object.keys(sessionStorage);
    const now = Date.now();
    
    keys.forEach(key => {
      if (!key.startsWith('idem_')) return;
      
      try {
        const stored = JSON.parse(sessionStorage.getItem(key));
        const age = now - stored.timestamp;
        
        // Remove keys older than 1 hour
        if (age > 60 * 60 * 1000) {
          sessionStorage.removeItem(key);
        }
      } catch {}
    });
  } catch (e) {
    console.warn('Failed to cleanup idempotency keys:', e);
  }
}